import React from 'react';

/*
 * Brand icons — purple-shaded SVGs that replace the generic emoji glyphs
 * (📚 / 📦) so the app's own visual identity reads instead of platform emoji.
 * Colours are the Orcanos purple ramp (see App.css :root):
 *   #7B52C8 (light) · #5C35A8 (base) · #3D2070 (dark) · #F5A623 (orange accent)
 *
 * Styling is self-contained (inline) on purpose: every stylesheet in this app
 * is global (Critical Note #15), so these icons carry no shared class name.
 */

const baseStyle = {
  display: 'inline-block',
  verticalAlign: '-0.16em',
  marginRight: '0.4em',
  flexShrink: 0,
};

// Product — an isometric cube in three purple faces (replaces 📦)
export function ProductIcon({ size = 20, style, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ ...baseStyle, ...style }}
    >
      {/* top face */}
      <path d="M12 2.4 21 6.9l-9 4.5-9-4.5z" fill="#8A63D4" />
      {/* left face */}
      <path d="M3 6.9 12 11.4v10.2l-9-4.5z" fill="#5C35A8" />
      {/* right face */}
      <path d="M21 6.9 12 11.4v10.2l9-4.5z" fill="#3D2070" />
      {/* top edge highlight */}
      <path d="M12 2.4 21 6.9l-9 4.5-9-4.5z" fill="#EAE5F5" fillOpacity="0.28" />
    </svg>
  );
}

// Knowledge — an open book (replaces 📚)
export function KnowledgeIcon({ size = 20, style, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ ...baseStyle, ...style }}
    >
      {/* left page */}
      <path
        d="M11.4 6.2C9.3 4.7 6.2 4.1 3.5 4.6a1 1 0 0 0-.8 1v12.1a1 1 0 0 0 1.2 1c2.2-.4 4.9.1 6.6 1.4a1 1 0 0 0 .9.1z"
        fill="#8A63D4"
      />
      {/* right page */}
      <path
        d="M12.6 6.2c2.1-1.5 5.2-2.1 7.9-1.6a1 1 0 0 1 .8 1v12.1a1 1 0 0 1-1.2 1c-2.2-.4-4.9.1-6.6 1.4a1 1 0 0 1-.9.1z"
        fill="#5C35A8"
      />
      {/* spine */}
      <rect x="11.1" y="6" width="1.8" height="14.6" rx="0.9" fill="#3D2070" />
      {/* orange bookmark accent */}
      <path d="M17.2 4.6v5.2l1.7-1.3 1.7 1.3V5.1z" fill="#F5A623" />
    </svg>
  );
}

export default { ProductIcon, KnowledgeIcon };
